import { render, staticRenderFns } from "./v20a7000pc.vue?vue&type=template&id=a96fd2b6&scoped=true&"
import script from "./v20a7000pc.vue?vue&type=script&lang=js&"
export * from "./v20a7000pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96fd2b6",
  null
  
)

export default component.exports